import { render, staticRenderFns } from "./lostFoundDetail.vue?vue&type=template&id=4d995d56&scoped=true&"
import script from "./lostFoundDetail.vue?vue&type=script&lang=js&"
export * from "./lostFoundDetail.vue?vue&type=script&lang=js&"
import style0 from "./lostFoundDetail.vue?vue&type=style&index=0&id=4d995d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d995d56",
  null
  
)

export default component.exports